import type { MailboxInfo } from "owa-client-types";

/**
 * Resolves a Unified Inbox mailbox to the concrete account that should be used
 * as the default Copilot chat context.
 */
export type UnifiedInboxCopilotResolver = (unifiedInboxMailboxInfo: MailboxInfo) => MailboxInfo;

let registeredResolver: UnifiedInboxCopilotResolver | undefined;

/**
 * Registers the resolver used to pick the default Copilot account for a Unified
 * Inbox mailbox. Copilot-eligibility lives in higher-level packages that depend
 * on owa-session-store, so it is injected here to avoid a circular dependency.
 * Registration is expected to happen eagerly from the Copilot layer; until then
 * callers fall back to the global settings account. Pass `undefined` to clear
 * the registered resolver.
 */
export function registerUnifiedInboxCopilotResolver(resolver: UnifiedInboxCopilotResolver | undefined): void {
    registeredResolver = resolver;
}

export function getRegisteredUnifiedInboxCopilotResolver(): UnifiedInboxCopilotResolver | undefined {
    return registeredResolver;
}
